import { clientReviewDoneSentence } from '../types/notifications';
export function formatRelativeTime(isoDate) {
    const now = Date.now();
    const then = new Date(isoDate).getTime();
    const diffMs = now - then;
    const minutes = Math.floor(diffMs / 60_000);
    if (minutes < 1)
        return 'just now';
    if (minutes < 60)
        return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24)
        return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    if (days < 7)
        return `${days}d ago`;
    return new Date(isoDate).toLocaleDateString();
}
function formatStatusLabel(status) {
    return status.replace(/-/g, ' ');
}
function truncate(str, max) {
    return str.length > max ? str.slice(0, max) + '...' : str;
}
export function formatNotificationTitle(notification) {
    const { data, type } = notification;
    const actor = data.actorName || 'Someone';
    const issue = data.issueTitle ? `"${truncate(data.issueTitle, 40)}"` : 'an issue';
    const formatters = {
        issue_status_changed: () => `${actor} changed ${issue}`,
        issue_created: () => `${actor} created ${issue}`,
        // Second person on purpose, and identical to the dashboard bell: an
        // issue_assigned row is only ever delivered to the assignee, so the reader
        // IS the assignee. See NotificationBell.tsx for the invariant.
        issue_assigned: () => `${actor} assigned ${issue} to you`,
        // The mirror, for the person the issue LEFT. assigneeName is the NEW
        // holder, absent when the assignee was cleared.
        issue_unassigned: () => {
            const nextAssignee = data.assigneeName;
            return nextAssignee
                ? `${actor} reassigned ${issue} to ${nextAssignee}`
                : `${actor} unassigned you from ${issue}`;
        },
        comment_added: () => {
            const preview = data.commentPreview ? `: "${truncate(data.commentPreview, 50)}"` : '';
            return `${actor} commented on ${issue}${preview}`;
        },
        mention: () => {
            const preview = data.commentPreview ? `: "${truncate(data.commentPreview, 50)}"` : '';
            return `${actor} mentioned you on ${issue}${preview}`;
        },
        client_note: () => {
            const who = data.isExternal ? (data.actorName || 'A reviewer') : actor;
            return `${who} left a comment on ${issue}`;
        },
        client_review_done: () => clientReviewDoneSentence(data.actorName, data.commentCount) + (data.clientReviewVersion ? ` · Version ${data.clientReviewVersion.sequence}` : ''),
    };
    return formatters[type]?.() || `${actor} performed an action`;
}
export function formatNotificationSubtitle(notification) {
    const { data, type } = notification;
    if (type === 'issue_status_changed' && (data.oldStatus || data.newStatus)) {
        return `${formatStatusLabel(data.oldStatus || '?')} → ${formatStatusLabel(data.newStatus || '?')}`;
    }
    if (type === 'issue_created' && data.projectName) {
        return `in ${data.projectName}`;
    }
    return null;
}
//# sourceMappingURL=notificationPresentation.js.map